import { render, staticRenderFns } from "./general-info.vue?vue&type=template&id=7c627874&scoped=true"
import script from "./general-info.vue?vue&type=script&lang=js"
export * from "./general-info.vue?vue&type=script&lang=js"
import style0 from "./general-info.vue?vue&type=style&index=0&id=7c627874&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c627874",
  null
  
)

export default component.exports